/**
 * Schools shown in the "Browse the full school library" grid. The grid renders
 * them alphabetically by localized short name (`sortSchoolsByShortName`), so
 * this list only defines membership.
 */
export const SCHOOL_LIBRARY_SLUG_ORDER = [
  'artificial-intelligence',
  'cloud-computing',
  'executive-leadership',
  'programming',
  'data-science',
  'autonomous-systems',
  'business',
  'cybersecurity',
  'career-resources',
  'animation-and-game-development',
  'product-management',
  'devops',
];

export const SCHOOL_LP_ANALYTICS_EVENT = 'Schools Page CTA Clicked';
